import React from 'react';
import {
    Box, CircularProgress, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Chip, Typography
} from '@material-ui/core';
import { WhatsAppTemplateType } from 'api/whatsapp/types';
import { IApiState } from 'store/types';
import { apiStatus } from 'shared/constants/AppEnum';
import HeadingCard from 'components/Card/HeadingCard';

interface TemplateTableProps {
    templates: WhatsAppTemplateType[];
    api: IApiState;
}

const TemplateTable: React.FC<TemplateTableProps> = ({ templates, api }) => {
    return (
        <HeadingCard title="WhatsApp Templates" cardContent={false} hasheaderBackground={false}>
            {api.status === apiStatus.LOADING ? (
                <Box display="flex" justifyContent="center" py={4}>
                    <CircularProgress />
                </Box>
            ) : templates.length === 0 ? (
                <Box textAlign="center" my={4}>
                    <Typography color="textSecondary">No templates found</Typography>
                </Box>
            ) : (
                <TableContainer component={Paper} elevation={0}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Category</TableCell>
                                <TableCell>Language</TableCell>
                                <TableCell>Header Type</TableCell>
                                <TableCell>Default</TableCell>
                                <TableCell>Updated</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {templates.map((template) => (
                                <TableRow key={template.id}>
                                    <TableCell>
                                        <Box>
                                            <Typography variant="body2" style={{ fontWeight: 600 }}>
                                                {template.template_name}
                                            </Typography>
                                            <Typography variant="caption" color="textSecondary">
                                                {template.description}
                                            </Typography>
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Chip
                                            label={template.category_display}
                                            size="small"
                                            variant="outlined"
                                        />
                                    </TableCell>
                                    <TableCell>{template.language}</TableCell>
                                    <TableCell>{template.header_type_display}</TableCell>
                                    <TableCell>
                                        {template.is_default && (
                                            <Chip label="Default" size="small" color="primary" />
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        {new Date(template.updated_at).toLocaleDateString()}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </HeadingCard>
    );
};

export default TemplateTable;
